import { render } from "./gameApplicationProposalDetails.vue?vue&type=template&id=9e3b00be&scoped=true"
import script from "./gameApplicationProposalDetails.vue?vue&type=script&lang=js"
export * from "./gameApplicationProposalDetails.vue?vue&type=script&lang=js"

import "./gameApplicationProposalDetails.vue?vue&type=style&index=0&id=9e3b00be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e3b00be"]])

export default __exports__